<template>
  <div id="gamer-select">
    <img id="gamer-image" :src="getGamerImg" />
    <div id="annual-salary">{{selectedCurrency}} {{annualSalary}} per year</div>
    <div id="gamer-tags">
      <div id="gamer-name">{{ selectedPlayer }}</div>
      <div id="gamer-cat">{{ playerCat }}</div>
    </div>
    <gamer-dropdown></gamer-dropdown>
  </div>
</template>

<style lang="scss" scoped>

#gamer-select {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin:40px;
 
}
#gamer-image {
  width: 200px;
}
#gamer-tags {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 20px 0px 20px 0px;
}

#gamer-name {
  background: $red;
  border-radius: 30px 0px 0px 30px;
  max-width: 240px;
  min-width:100px;
  color: $white;
  text-align: center;
  padding: 10px 30px 10px 30px; 
  @include respond(phone-only){
    font-size:14px;
  }
}

#gamer-cat {
  background: $orange;
  color: $white;
  border-radius: 0px 30px 30px 0px;
  max-width: 240px;
  min-width:100px;
  text-align: center;
  padding: 10px 30px 10px 30px; 
   @include respond(phone-only){
    font-size:14px;
  }
}

#annual-salary{
  font-size:30px;
  margin:-10px 0px 0px 0px;
  color:$white;
  padding:0px 10px 0px 10px;
   @include respond(phone-only){
    font-size:20px;
  }
}
.highlight {
  color: $yellow;
}
</style>

<script>
import GamerDropdown from "@/components/GamerSalary/GamerDropdown";
export default {
  components: {
    GamerDropdown,
  },
  data() {
    return {
      gamerData: [],
      chosenPic:"unknown.png",
    };
  },
  computed: {
    selectedPlayer() {
      return this.$store.getters.getGamerData.gamerId;
    },
    playerCat() {
      return this.$store.getters.getGamerData.category;
    },
    getGamerImg() {
      return require("../../assets/images/gamers/" + this.$store.getters.getGamerData.image);
    },
    selectedCurrency() {
      return this.$store.getters.getCurrencySymbol;
    },
    annualSalary(){
      
      var earnings = this.$store.getters.getGamerData.annualEarnings * this.$store.getters.getCurrencyRate;
      return this.humanFormat(Math.floor(earnings));
    }
  },
  methods: {
    humanFormat(profit) {
      return new Intl.NumberFormat().format(profit);
    },
  },
  mounted() {
    this.gamerData = this.$store.getters.getGamerData;
  },
};
</script>